import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    standalone: true,
    selector: '[noSpacesNoSpecial]'
})
export class NoSpacesNoSpecialDirective {
    private regex: RegExp = /^[a-zA-Z0-9_-]*$/;

    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInputChange(event: Event) {
        const input = this.el.nativeElement as HTMLInputElement;
        if (!this.regex.test(input.value)) {
            // Remove invalid characters
            input.value = input.value.replace(/[^a-zA-Z0-9_-]/g, '');
        }
    }

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        const char = String.fromCharCode(event.keyCode || event.which);
        if (!this.regex.test(char)) {
            event.preventDefault();
        }
    }
}
